function injectStyle (ssrContext) {
  require("!!../../../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?minimize!../../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-2db3f525\",\"scoped\":true,\"hasInlineConfig\":true}!sass-loader!../../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Paginator.vue")
}
var Component = require("!../../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Paginator.vue"),
  /* template */
  require("!!../../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2db3f525\",\"hasScoped\":true,\"preserveWhitespace\":false}!../../../../../../../../node_modules/vue-loader/lib/template-compiler/preprocessor?engine=pug!../../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Paginator.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2db3f525",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/profile/modules/remote-edu/examination-item/components/pagination/Paginator.vue
// module id = b3a05d4cbdcfaad2b0fd
// module chunks = 3